<template>
    <div class="approval-files">
        <el-collapse v-model="activeNames" accordion>
            <el-collapse-item title="审批流文件列表" name="approvalFile">
                <div>
                    <div style="z-index: 333;height: 36px;position: absolute;right: 10px;line-height: 36px;">
                        <el-upload
                            class="upload-demo"
                            ref="uploadObj"
                            :action="uploadUrl"
                            :data="uploadData"
                            :file-list="uploadFiles"
                            :show-file-list="false"
                            :on-preview="handleFile"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-change="uploadOnChange"
                            :on-success="handleImportSuccess"
                            :on-error="uploadOnError"
                            :before-upload="beforeImport"
                            :on-progress="uploadOnProgress"
                            multiple
                            >
                            <el-tooltip content="一次上传的文件大小总量不超过1000M" effect="light" placement="top">
                                <el-button v-if="!isApprovalMode && !isIconUploadBtn && isCouldUpload" icon="el-icon-upload" size="mini" type="primary">上传文件</el-button>
                                <el-button v-if="!isApprovalMode && isIconUploadBtn" icon="el-icon-upload" size="mini"  title="上传文件" type="primary" circle></el-button>
                            </el-tooltip>
                            <el-button class='print-class' v-if="!isFullScreen" type="primary" icon="el-icon-rank"  size="mini" @click.stop="handleFullScreen()">全屏</el-button>
                            <el-button icon="el-icon-top"  v-if="isShowBackBtn"  title='返回上一页' type="warning" size="mini"  @click.stop="handleGoArchiveNav()">返回</el-button>
                        </el-upload>
                        <iframe :src="downloadUrl" width="0" height="0" frameborder="0" />
                    </div>
                </div>
                <div v-if="!pass && progress !== 0" >
                    <el-progress :text-inside="true" :stroke-width="18" :percentage="progress" :status="proStatus"></el-progress>
                </div>
                <div v-if="this.bizType === 'process' || this.bizType ==='task' || this.bizType === 'approval' " style="height: 40px;" @keyup.enter="handleFileSearch">
                    <el-form :inline="true" >
                        <el-form-item label="审核状态">
                            <el-select style="width:120px;" v-model="searchFileParams.approvalStatus" @change="handleFileSearch" placeholder="请选择">
                                <el-option
                                    v-for="item in approvalStatusArr"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="上传人员" >
                            <el-input style="width:135px" readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                            <UserOrgPop :multiple="false" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectTrigger"  />
                        </el-form-item>
                        <el-form-item label="文件名称">
                            <el-input style="width:200px"  maxlength="100" v-model.trim="searchFileParams.fileName" placeholder="">
                                <el-button slot="append" icon="el-icon-search" @click="handleFileSearch"></el-button>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button class='print-class' v-permission="permission.archiveApprovalBtn"  v-if="isApprovalMode" title='对选择的文件进行归档审批' type="primary" size="mini" icon="el-icon-receiving"  @click.stop="handleBathApprovalFiles()">批量审核</el-button>
                        </el-form-item>
                        <!-- <el-form-item v-if="belongProcessFlag>0">
                            <el-tooltip class="item" effect="dark" content="共享流程可见后，可以在我的流程或我的任务的文件列表处可见" placement="top">
                                <el-checkbox v-model="shareChecked">文件共享流程可见</el-checkbox>
                            </el-tooltip>
                        </el-form-item> -->
                    </el-form>
                </div>
                <div v-if="this.bizType === 'process' || this.bizType ==='task' || this.bizType ==='approval'" class="approval-files-list">
                    <el-table :data="filesList"  :border="true" @selection-change="handleSelectionChange" :height="tableAutoHeight">
                        <el-table-column v-if="isApprovalMode" type="selection" width="55"></el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="fileName" label="文件名称" >
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >
                                    <div  style="cursor:pointer;" @click.stop="readFile(scope.row)">
                                        <span style="font-size:16px;color:#f56c6c">●</span>
                                        {{scope.row.fileName}}
                                    </div>
                                </template>
                                <template v-if="scope.row.readStatus === 1" >
                                    {{scope.row.fileName}}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true"   prop="taskName" label="文件来源" width="100">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >{{scope.row.taskName}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="fileDesc" label="备注说明" >
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >
                                    <div v-if="scope.row.fileDesc != undefined && scope.row.fileDesc != ''" style="cursor:pointer;" @click.stop="handleFileDesc(scope.row)">
                                        {{scope.row.fileDesc}}
                                    </div>
                                    <div v-else style="cursor:pointer;" @click.stop="handleFileDesc(scope.row)">&nbsp;</div>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true"  prop="processInstanceName" label="所属流程" width="100">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >{{scope.row.processInstanceName}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="filesLabel"  label="文件标签" width="100px">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >
                                    <div  v-if="scope.row.tagLabels!=null && scope.row.tagLabels!=''" >
                                        <el-tag v-if="scope.row.filesLabel!=null  && scope.row.filesLabel!=''" :type="'primary'" >{{scope.row.filesLabel}}</el-tag>
                                    </div>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="archiveLabel"  label="档案目录" width="150">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >
                                    <el-tag v-if="scope.row.archiveLabel!=null  && scope.row.archiveLabel!=''" :type="'success'" >{{scope.row.archiveLabel}}</el-tag>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="trueName" label="上传人" width="60" >
                            <template slot-scope="scope">
                                {{scope.row.trueName}}
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" :sortable="true" prop="created" label="上传时间"  width="140" ></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="fileByteSize" label="大小" width="80">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" > {{scope.row.fileByteSize | getfilesize }}</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="approvalStatus" label="归档状态" width="80">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <!-- <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 0" >草稿</template> -->
                                <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 1" >审核中</template>
                                <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 2" >归档通过</template>
                                <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 3" >归档驳回</template>
                                <template v-if="scope.row.readStatus === 1 && (scope.row.approvalStatus === 99 || scope.row.approvalStatus === 0)" >未归档</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="trueName" label="审核人" width="60" >
                            <template slot-scope="scope">
                                {{scope.row.approvaler}}
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" :sortable="true" prop="approvalTime" label="审核时间"  width="140" ></el-table-column>
                        <el-table-column   fixed="right" label="操作" width="300">
                            <template slot-scope="scope">
                                <el-button type="primary" :loading="downLoading"  size="mini" icon="el-icon-download" title="下载" circle @click.stop="handleDownload(scope.row)"></el-button>
                                <el-button type="success" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row)"></el-button>
                                <el-button type="warning" v-if="approvalInstanceStatus===2 && !scope.row.viewForProcess && currentUser.userId === scope.row.createdBy" size="mini" icon="el-icon-video-play" title="共享给所属流程任务" circle  @click.stop="handleArchiveFileApply(scope.row)"></el-button>
                                <el-button type="primary" v-if="approvalInstanceStatus===2 && scope.row.viewForProcess && currentUser.userId === scope.row.createdBy" size="mini" icon="el-icon-video-pause" title="取消共享给所属流程任务" circle  @click.stop="handleDelArchiveFileApply(scope.row)"></el-button>
                                <el-button type="danger"  v-if="isCouldDelete && currentUser.userId === scope.row.createdBy" size="mini" icon="el-icon-delete" title="删除" circle @click="handleFileDelete(scope.row)"></el-button>
                                <br />
                                <el-button type="danger" size="mini" icon="iconfont icon-other-gaizhang" title="盖章" circle @click="handlePrintFile(scope.row)" v-if="scope.row.showSignBtn"></el-button>
                                <el-button type="primary" size="mini" icon="iconfont icon-other-tubiaolunkuo_huaban" title="下载盖章文件" circle @click="downSignFile(scope.row)" v-if="scope.row.showSignBtn"></el-button>
                                <el-button type="warning" size="mini" icon="el-icon-s-unfold" title="盖章记录" circle @click="getSignRecord(scope.row)"  v-if="scope.row.showSignBtn"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-row type="flex" justify="end">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :total="filePage.totalPageNum"
                            :current-page="filePage.currentPage"
                            :page-size="filePage.pageSize"
                            @current-change="queryListData"
                        />
                    </el-row>
                </div>
            </el-collapse-item>
            <el-collapse-item v-if="this.bizType ==='approval' && taskFilesList.length > 0" title="所属任务的文件列表" name="taskFile">
                <div class="task-files-list">
                    <el-table :data="taskFilesList" :height="tableAutoHeight" :border="true">
                        <el-table-column  :show-overflow-tooltip="true" prop="fileName" label="文件名称" >
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >
                                    <div  style="cursor:pointer;" @click.stop="readFile(scope.row)">
                                        <span style="font-size:16px;color:#f56c6c">●</span>
                                        {{scope.row.fileName}}
                                    </div>
                                </template>
                                <template v-if="scope.row.readStatus === 1" >
                                    {{scope.row.fileName}}
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true"   prop="taskName" label="文件来源" width="100">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >{{scope.row.taskName}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="fileDesc" label="备注说明" >
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >
                                    <div v-if="scope.row.fileDesc != undefined && scope.row.fileDesc != ''" style="cursor:pointer;" @click.stop="handleFileDesc(scope.row)">
                                        {{scope.row.fileDesc}}
                                    </div>
                                    <div v-else style="cursor:pointer;" @click.stop="handleFileDesc(scope.row)">&nbsp;</div>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true"  prop="processInstanceName" label="所属流程" width="100">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >{{scope.row.processInstanceName}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="filesLabel"  label="文件标签" width="100px">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >
                                    <div  v-if="scope.row.tagLabels!=null && scope.row.tagLabels!=''" >
                                        <el-tag v-if="scope.row.filesLabel!=null  && scope.row.filesLabel!=''" :type="'primary'" >{{scope.row.filesLabel}}</el-tag>
                                        <!-- <el-tag v-if="scope.row.archiveLabel!=null  && scope.row.archiveLabel!=''" :type="'success'" >{{scope.row.archiveLabel}}</el-tag> -->
                                    </div>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="archiveLabel"  label="档案目录" width="150">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" >
                                    <el-tag v-if="scope.row.archiveLabel!=null  && scope.row.archiveLabel!=''" :type="'success'" >{{scope.row.archiveLabel}}</el-tag>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="trueName" label="上传人" width="60" >
                            <template slot-scope="scope">
                                {{scope.row.trueName}}
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" :sortable="true" prop="created" label="上传时间"  width="140" ></el-table-column>
                        <el-table-column :show-overflow-tooltip="true" prop="fileByteSize" label="大小" width="80">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <template v-if="scope.row.readStatus === 1" > {{scope.row.fileByteSize | getfilesize }}</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="approvalStatus" label="归档状态" width="80">
                            <template slot-scope="scope">
                                <template v-if="scope.row.readStatus === 0" >...</template>
                                <!-- <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 0" >草稿</template> -->
                                <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 1" >审核中</template>
                                <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 2" >归档通过</template>
                                <template v-if="scope.row.readStatus === 1 && scope.row.approvalStatus === 3" >归档驳回</template>
                                <template v-if="scope.row.readStatus === 1 && (scope.row.approvalStatus === 99 || scope.row.approvalStatus === 0)" >未归档</template>
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" prop="trueName" label="审核人" width="60" >
                            <template slot-scope="scope">
                                {{scope.row.approvaler}}
                            </template>
                        </el-table-column>
                        <el-table-column  :show-overflow-tooltip="true" :sortable="true" prop="approvalTime" label="审核时间"  width="140" ></el-table-column>
                        <el-table-column   fixed="right" label="操作" width="300">
                            <template slot-scope="scope">
                                <el-button type="primary" :loading="downLoading"  size="mini" icon="el-icon-download" title="下载" circle @click.stop="handleDownload(scope.row)"></el-button>
                                <el-button type="success" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row)"></el-button>
                                <el-button type="warning" v-if="approvalInstanceStatus===2 && !scope.row.viewForProcess && currentUser.userId === scope.row.createdBy" size="mini" icon="el-icon-video-play" title="共享给所属流程任务" circle  @click.stop="handleArchiveFileApply(scope.row)"></el-button>
                                <el-button type="primary" v-if="approvalInstanceStatus===2 && scope.row.viewForProcess && currentUser.userId === scope.row.createdBy" size="mini" icon="el-icon-video-pause" title="取消共享给所属流程任务" circle  @click.stop="handleDelArchiveFileApply(scope.row)"></el-button>
                                <el-button type="danger"  v-if="isCouldDelete && currentUser.userId === scope.row.createdBy" size="mini" icon="el-icon-delete" title="删除" circle @click="handleFileDelete(scope.row)"></el-button>
                                <br />
                                <el-button type="danger" size="mini" icon="iconfont icon-other-gaizhang" title="盖章" circle @click="handlePrintFile(scope.row)" v-if="scope.row.showSignBtn"></el-button>
                                <el-button type="primary" size="mini" icon="iconfont icon-other-tubiaolunkuo_huaban" title="下载盖章文件" circle @click="downSignFile(scope.row)" v-if="scope.row.showSignBtn"></el-button>
                                <el-button type="warning" size="mini" icon="el-icon-s-unfold" title="盖章记录" circle @click="getSignRecord(scope.row)"  v-if="scope.row.showSignBtn"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-row type="flex" justify="end">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :total="taskFilePage.totalPageNum"
                            :current-page="taskFilePage.currentPage"
                            :page-size="taskFilePage.pageSize"
                            @current-change="queryTaskFileListData"
                        />
                    </el-row>
                </div>
            </el-collapse-item>
        </el-collapse>
        <el-dialog
            title="选择档案目录"
            append-to-body
            :visible.sync="isShowArchiveTemplateTree">
            <ArchiveTemplateTree
                ref="treeChild"
                :key="loadTimer"
                :popover="true"
                :templateId="templateId"
                :processInstanceId="processInstanceId"
                :isInstance="true"
                :defaultProps="{}"
                @nodeClick="handleTreeNode"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowArchiveTemplateTree = false">取 消</el-button>
                <el-button type="primary" @click="chooseArchiveNodeConfirm">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="文件说明"
            top="4vh"
            width="55%"
            :visible.sync="isShowFileDesc"
            :before-close="handleClose"
            append-to-body
            >
            <el-form ref="selectFileForm" :model="selectedFile" size="mini" label-width="120px">
                <el-form-item label="文件名称" prop="fileName">
                    <el-input v-model="selectedFile.fileName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="文件说明" prop="fileDesc"
                    :rules="[
                    { min: 0, max: 1000, message: '长度在1000个字符内', trigger: 'blur' }
                    ]">
                    <el-input type="textarea" v-model="selectedFile.fileDesc"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateFileDesc">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="approvalDialogTile"
            :visible.sync="isShowApprovalDialog"
            append-to-body
            >
            <el-form :model="approvalInfo" ref="approvalInfoForm" size="mini" label-width="120px">
                <el-row>
                    <el-form-item label="审批文件">
                        <el-input disabled type="textarea" :autosize="{ minRows: 3, maxRows: 10}" v-model="selectedFiles.selectedFileNames"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item  label="审批结论">
                    <el-radio-group v-model="approvalInfo.status" size="mini" class="exec-type">
                        <el-radio :label="2">通过</el-radio>
                        <el-radio :label="3">驳回</el-radio>
                    </el-radio-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="审批描述"  prop="approveDesc">
                    <el-input placeholder="请输入内容"  type="textarea" :autosize="{ minRows: 6, maxRows: 10}" v-model="approvalInfo.approveDesc"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowApprovalDialog = false">取 消</el-button>
                  <el-button type="primary" @click="handleFinalApproval" :loading="startProcessloading">确 定</el-button>
              </span>
          </el-dialog>
        <el-dialog
            title="配置文件可见任务"
            append-to-body
            :visible.sync="isShowFileCanViewPop">
            <ProcessTaskSelectPop
                ref="processTaskSelectPop"
                :key="loadTimer"
                :processInstanceId="processInstanceId"
                :fileId="currentFileId"
                @cancel="taskSelectConfirmClick"
                @confirm="taskSelectConfirmClick"
            />
        </el-dialog>
        <el-dialog
            append-to-body
            top="3vh"
            width="95%"
            :visible.sync="dialogVisible">
            <div width="100%" style="text-align:center;">
            <img :src="dialogImageUrl" alt="" style="max-height:100%;max-width:100%;">
            </div>
        </el-dialog>
        <el-dialog
          title="盖章记录"
          :visible.sync="showFileSignRecord"
          v-if="showFileSignRecord"
          destroy-on-close
          append-to-body
          top="1vh"
          width="80%"
          >
            <SignatureFileRecord :filePath="filePath" v-if="showFileSignRecord"></SignatureFileRecord>
        </el-dialog>
    </div>
</template>

<script>
    import mixinsNav from '@/mixins/mixins-nav';
    import SelectMultiple from '@/components/SelectMultiple';
    import ProcessTaskSelectPop from '@/components/ProcessTaskSelectPop';
    import { getPreviewFileUrl } from '@/utils/grocer';
    import { isEmpty, cloneDeep } from 'lodash';
    import { signUrl } from '@/common/constants/const-global';
    import SignatureFileRecord from '@/pages/system/signatureFileList/signatureFileRecord';
    import { mapGetters } from 'vuex';
    import { API_IMG_DOWNLOAD, CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN, API_PROCESS_TASK_UPLOAD_FILE, API_PROCESS_INSTANCES_UPLOAD_FILE, API_FILE_DOWNLOAD, API_DOCUMENT_PUBLICLIBRARY_UPLOAD_FILE, API_DOCUMENT_ARCHIVE_TEMPLATE_UPLOAD_FILE } from '@/common/constants';
    import { addApprovalFileViewForProcessByIds, delApprovalFileViewForProcessByIds, getApprovalInstanceFiles, approvalArchiveFileByIds, saveTags, delProcessFileShare,
        addProcessFileShare, getUserList, getProcessTaskFiles, getProcessInstanceFiles, delTaskFile, delProcessFile, addProcessFileReadRecord,
        batchUpdProcessFilesStatus, updateFileDesc, downloadFiles, setSignatureRecordParam, getSignatureRecord, getProcessTaskInfo } from '@/data-model';

    export default {
        mixins: [ mixinsNav ],
        components: {
            // FileList,
            ProcessTaskSelectPop,
            SelectMultiple,
            SignatureFileRecord
        },
        data () {
            return {
                activeNames: 'approvalFile',
                // 审批流文件列表 带出关联任务的文件begin
                searchTaskFileParams: {
                    approvalStatus: 999,
                    fileName: '',
                    processInstanceId: '',
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    userId: '',
                    trueName: '',
                    selectTags: '', // 标签
                    selectArchives: '' // 档案目录
                },
                taskFilePage: {
                    currentPage: 1, // 当前页码
                    pageSize: 5, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                taskFilesList: [],
                // 审批流文件列表 带出关联任务的文件end
                dialogImageUrl: '',
                dialogVisible: false,
                currentUser: {},
                currentFileId: '',
                isShowFileCanViewPop: false,
                selectedFiles: {
                    selectedFileIds: '', // 选中的文件ID
                    selectedFileNames: '' // 选中的文件名称
                },
                approvalInfo: {
                    templateId: '',
                    processInstanceId: '',
                    status: 2,
                    approveDesc: ''
                },
                approvalDialogTile: '文件审核',
                startProcessloading: false,
                isShowApprovalDialog: false,
                loadTimer: '',
                downLoading: false,
                shareChecked: true, // 默认审批流发起的流程共享给流程可见
                isShowUserOrg: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                valueConsistsOf: 'ALL',
                isShowArchiveTemplateTree: false,
                sourceOptions: [],
                isRefreshSel: true,
                userList: [],
                loading: null,
                proStatus: '', // 上传状态
                progress: 0, // 上传进度
                pass: null, // 是否上传成功
                isShowTag: false,
                selectTags: [],
                filePage: {
                    currentPage: 1, // 当前页码
                    pageSize: 5, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                filesList: [],
                uploadData: {
                    processInstanceId: undefined,
                    taskInstanceId: undefined,
                    treeId: '',
                    treeName: '',
                    templateId: ''
                },
                approvalStatusArr: [{
                    value: 999,
                    label: '全部'
                }, {
                    value: 99,
                    label: '未归档'
                }, {
                    value: 1,
                    label: '审核中'
                }, {
                    value: 2,
                    label: '审核通过'
                }, {
                    value: 3,
                    label: '审核驳回'
                }],
                searchFileParams: {
                    approvalStatus: 999,
                    fileName: '',
                    processInstanceId: '',
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    userId: '',
                    trueName: '',
                    selectTags: '', // 标签
                    selectArchives: '' // 档案目录
                },
                uploadFiles: [],
                downloadUrl: '',
                selectedRow: {},
                targetDirectory: {// 选择的档案模板目录节点
                    targetDirectoryId: '',
                    targetDirectoryName: ''
                },
                sourceTags: [],
                isShowApprovalFilesDialog: false,
                approvalFilesDirId: '',
                approvalFilesDirName: '',
                uploadFinishFiles: [], // 已经上传完毕的文件列表
                isShowFileDesc: false,
                selectedFile: {
                    id: '',
                    fileName: '',
                    fileDesc: ''
                },
                permission: {
                    archiveApprovalBtn: [// 业务档案文件审核
                        CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN
                    ]
                },
                filePath: '',
                showFileSignRecord: false,
                signProcessServiceId: '',
                signBusiTaskInstanceId: '',
                signBusiProcessInstanceId: '',
                signDeploymentId: '',
                signTemplateId: '',
                tableAutoHeight: 'auto'
            };
        },
        filters: {// 如下这样写
            getfilesize: function (size) {
                // console.log(size);
                if (!size) {
                    return '';
                }
                var num = 1024.00; // byte
                if (size < num) { return size + '(B)'; }
                if (size < Math.pow(num, 2)) { return (size / num).toFixed(2) + '(K)'; } // kb
                if (size < Math.pow(num, 3)) { return (size / Math.pow(num, 2)).toFixed(2) + '(M)'; } // M
                if (size < Math.pow(num, 4)) { return (size / Math.pow(num, 3)).toFixed(2) + '(G)'; } // G
                return (size / Math.pow(num, 4)).toFixed(2) + '(T)'; // T
            }
        },
        props: {
            approvalInstanceStatus: {// 审批流实例状态
                type: Number,
                default: 0
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: true
            },
            isApprovalMode: {// 审核模式
                type: Boolean,
                default: false
            },
            isShowBackBtn: {// 显示返回上一页按钮
                type: Boolean,
                default: false
            },
            bizType: { // 文件上传的类型。 task、process
                type: String
                // default: 'process'
            },
            taskId: {
                type: String
            },
            processInstanceId: {
                type: String
            },
            treeId: {
                type: String
            },
            treeName: {
                type: String
            },
            templateId: {
                type: String
            },
            isIconUploadBtn: {
                type: Boolean,
                default: false
            },
            busiProcessInstanceId: {
                type: String
            },
            busiTaskInstanceId: {
                type: String
            },
            belongProcessFlag: {// 审批流来源：0默认 1我的流程发起审批流 2任务上发起审批流
                type: Number,
                default: 0
            },
            isSubProcess: {
                type: Boolean,
                default: false
            },
            modelInstanceId: {
                type: String
            },
            isShowArchive: {// 用于审批流的标识，是否显示归档列
                type: Boolean,
                default: true
            },
            isCouldUpload: {// 用于审批流的标识，是否允许上传
                type: Boolean,
                default: true
            },
            isCouldDelete: {// 用于审批流的标识，是否允许删除
                type: Boolean,
                default: true
            }
        },
        watch: {
            treeId (newVal, oldVal) {
                this.uploadData.treeId = this.treeId;
            },
            templateId () {
                this.uploadData.templateId = this.templateId;
            },
            processInstanceId () {
                this.uploadData.processInstanceId = this.processInstanceId;
            },
            modelInstanceId () {
                this.uploadData.modelInstanceId = this.modelInstanceId;
            }
        },
        computed: {
            uploadUrl () {
                let url = '';
                let prefix = '';
                let env = process.env.NODE_ENV;
                if (env === 'production') {
                    prefix = '/bcbpm';
                }
                if (this.bizType === 'task') {
                    url = prefix + API_PROCESS_TASK_UPLOAD_FILE;
                } else if (this.bizType === 'process' || this.bizType === 'approval') {
                    url = prefix + API_PROCESS_INSTANCES_UPLOAD_FILE;
                } else if (this.bizType === 'publicLibrary') {
                    url = prefix + API_DOCUMENT_PUBLICLIBRARY_UPLOAD_FILE;
                } else if (this.bizType === 'archiveInstance') {
                    url = prefix + API_DOCUMENT_ARCHIVE_TEMPLATE_UPLOAD_FILE;
                }
                // console.log(url);
                return url;
            },
            ...mapGetters([
                'userInfo'
            ])
            // proStatus(){//上传状态
            // let status="";
            //   if(this.pass){
            //     status="success";
            //   }else if(this.pass == false){
            //     status="exception";
            //   }
            //   // console.log(status);
            //   return status;
            // }
        },
        mounted () {
            this.$nextTick(function () {
                if (this.taskFilesList.length > 0) {
                    this.tableAutoHeight = (window.innerHeight / 4) + 60 + 'px';
                } else {
                    this.tableAutoHeight = window.innerHeight / 2;
                }
            });
        },
        created () {
            if (this.processInstanceId) { // 通过审批流流程获取任务的ID
                this.getProcessTaskInfo();
            }
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            let currentUserInfo = JSON.parse(currentUserStr);
            this.currentUser = currentUserInfo;
            if (this.bizType === 'process' || this.bizType === 'task' || this.bizType === 'approval') {
                if (this.isApprovalMode) { // 审核模式，只查询待审核的文件
                    this.searchFileParams.approvalStatus = 1;
                }
                this._initPage();
                this.uploadData = {
                    processInstanceId: this.processInstanceId,
                    taskInstanceId: this.taskId
                };
            } else if (this.bizType === 'publicLibrary') {
                this.uploadData = {
                    treeId: this.treeId,
                    treeName: this.treeName
                };
            } else if (this.bizType === 'archiveInstance') {
                this.uploadData = {
                    treeId: this.treeId,
                    treeName: this.treeName,
                    templateId: this.templateId,
                    processInstanceId: this.processInstanceId,
                    modelInstanceId: this.modelInstanceId
                };
            }
        },
        methods: {
            async getProcessTaskInfo () {
                let param = {processInstanceId: this.processInstanceId};
                let res = await getProcessTaskInfo(param);
                if (res && res.state == 'success') {
                    this.signProcessServiceId = res.processServiceId;
                    this.signBusiTaskInstanceId = res.busiTaskInstanceId;
                    this.signBusiProcessInstanceId = res.busiProcessInstanceId;
                    this.signDeploymentId = res.deploymentId;
                    this.signTemplateId = res.templateId;

                    // 查询关联的任务的文件列表
                    this.handleTaskFileSearch().then(val => {
                        if (this.filesList.length === 0 && this.taskFilesList.length > 0) {
                            this.activeNames = 'taskFile';
                        }
                    });
                }
            },
            async isShowSignBtnState (row) {
                let filePath = row.filePath;
                let param = {filePath: filePath};
                let res = await getSignatureRecord(param);
                if (res && res.state == 'success') {
                    if (res.signList && res.signList.length > 0) {
                        let obj = res.signList[res.signList.length - 1];
                        row.nowFileName = obj.nowFileName;
                        row.nowFilePath = obj.nowFilePath;
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            getSignRecord (obj) {
                this.filePath = obj.filePath;
                this.showFileSignRecord = true;
            },
            async downSignFile (row) {
                // 拿到当前文件请求后台查出最新的记录
                let filePath = row.filePath;
                let param = {filePath: filePath};
                let res = await getSignatureRecord(param);
                if (res && res.state == 'success') {
                    if (res.signList && res.signList.length > 0) {
                        let obj = res.signList[0];
                        let url = `${API_FILE_DOWNLOAD}${obj.nowFilePath}`;
                        this.download(url);
                    } else {
                        this.$message.error('文件还没有盖过章');
                    }
                } else {
                    this.$message.error('文件还没有盖过章');
                }
            },
            async handlePrintFile (obj) {
                let url = signUrl;
                // obj.formId=this.formId;
                if (this.userInfo.userId) {
                    obj.userId = cloneDeep(this.userInfo.userId);
                    obj.tenantId = cloneDeep(this.userInfo.tenantId);
                    obj.taskId = cloneDeep(this.signBusiTaskInstanceId);
                    obj.processInstanceId = cloneDeep(this.signBusiProcessInstanceId);
                    obj.processServiceId = cloneDeep(this.signProcessServiceId);
                    obj.templateId = cloneDeep(this.signTemplateId);
                    obj.deploymentId = cloneDeep(this.signDeploymentId);
                }
                // 参数存储到redis
                let res = await setSignatureRecordParam(obj);
                url += '?param=' + res.signId;
                window.open(url);
            },
            isHasAuth () {
                let isEditAuth = false;
                let currentUserStr = sessionStorage.getItem('currentUserInfo');
                if (currentUserStr) {
                    let currentUserInfo = JSON.parse(currentUserStr);
                    let resources = currentUserInfo.resources;
                    if (resources) {
                        for (let i = 0; i < resources.length; i++) {
                            if (resources[i].resourceUrl === 'electronicSignature') { // 是否可以点击报表进行数据修改
                                isEditAuth = true;
                                break;
                            }
                        }
                    }
                }
                return isEditAuth;
            },
            getProcessShareValue () {
                let isProcessShare = 0;
                if (this.shareChecked) {
                    isProcessShare = 1;
                }
                return isProcessShare;
            },
            /** 清理已经上传的文件 */
            _clearUploadFiles () {
                this.$refs.uploadObj.clearFiles();
                this.uploadFinishFiles = [];
            },
            uploadOnProgress (e, file) { // 开始上传
                // console.log(e.percent,file)
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.progress = Math.floor(e.percent);
                if (this.progress > 0 && this.progress < 100) {
                    this.proStatus = 'exception';
                } else if (this.progress === 100) {
                    this.proStatus = 'success';
                }
            },
            uploadOnChange (file) {
                // console.log(file)
                if (file.status === 'ready') {
                    // console.log("ready")
                    this.pass = undefined;
                    this.progress = 0;
                } else if (file.status === 'fail') {
                    this.$message.error('文件上传出错，请刷新重试！');
                }
            },
            handleImportSuccess (res, file, fileList) {
                // 检查所选择的文件是否全部上传完毕
                let isFinish = true;
                this.uploadFinishFiles.push(file.name);
                for (const index in fileList) {
                    if (fileList[index].status !== 'success') {
                        isFinish = false;
                        break;
                    }
                    // if (fileList.hasOwnProperty(index)) {
                    //     let tmp = this.uploadFinishFiles.includes(fileList[index].name);
                    //     isFinish = tmp;
                    //     if (tmp === false) {
                    //         break;
                    //     }
                    // }
                }
                // 如果没有全部上传完成，忽略本次上次回调
                if (!isFinish) {
                    return;
                }

                this.pass = true;
                if (this.loading) {
                    this.loading.close();
                    this.loading = undefined;
                }
                this.$message.success('上传成功');
                // console.log(file);
                if (this.bizType === 'process' || this.bizType === 'task' || this.bizType === 'approval') {
                    this.handleFileSearch();
                } else {
                    this.$emit('getFileList');
                }
                this._clearUploadFiles();
            },
            uploadOnError (e, file) {
                this.pass = false;
            },
            async _initPage () {
                this.handleFileSearch();
                this.queryUserList('');
            },
            queryListData (currentPage) {
                this.filePage.currentPage = currentPage;
                this.handleFileSearch();
            },
            async _getTaskFiles () {
                let { data } = await getProcessTaskFiles(this.taskId);
                this.uploadFiles = data.map(item => {
                    item.name = item.fileName;
                    return item;
                });
            },
            async _getProcessFiles () {
                let { data } = await getProcessInstanceFiles(this.processInstanceId);
                this.uploadFiles = data.map(item => {
                    item.name = item.fileName;
                    return item;
                });
            },
            handleFile (file) {
                // console.log(file);
                let url = `${API_FILE_DOWNLOAD}${file.filePath}`;
                this.download(url);
                // console.log("routerName:"+routerName);
                // this.downloadUrl = `${API_FILE_DOWNLOAD}${file.filePath}`;
                // this.$router.push({name: `${API_FILE_DOWNLOAD}${file.filePath}`,params:{}});
            },
            download (url) {
                url = url.replace('processInstanceId=', 'processInstanceId=' + this.processInstanceId);
                // console.log(url);
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
                downloadFiles(url);
            },
            beforeImport (file) {
                const isLt350M = (file.size / 1024 / 1024 < 3096);
                if (!isLt350M) {
                    this.$message.error('上传文件大小不能超过 3G!');
                }
                return isLt350M;
            },
            beforeRemove (file) {
                return this.$confirm(`您确定要删除文件[ ${file.name} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
            },
            async handleRemove (file) {
                // console.log(file);
                let param = {
                    processInstanceId: this.processInstanceId,
                    taskInstanceId: this.taskId,
                    fileId: file.id
                };
                if (this.bizType === 'task') {
                    await delTaskFile(param);
                } else if (this.bizType === 'process') {
                    await delProcessFile(param);
                } else if (this.bizType === 'approval') {
                    await delProcessFile(param);
                }
                await this._initPage();
            },
            async handleFileSearch () {
                this.filesList = [];
                this.searchFileParams.processInstanceId = this.processInstanceId;
                this.searchFileParams.taskId = this.taskId;
                this.searchFileParams.currentPage = this.filePage.currentPage;
                this.searchFileParams.pageSize = this.filePage.pageSize;
                let formData;
                if (this.bizType === 'process') {
                    this.searchFileParams.isApprovalMode = this.isApprovalMode;
                    formData = await getProcessInstanceFiles(this.searchFileParams);
                } else if (this.bizType === 'task') {
                    // console.log(this.searchFileParams);
                    formData = await getProcessTaskFiles(this.searchFileParams);
                } else if (this.bizType === 'approval') {
                    formData = await getApprovalInstanceFiles(this.searchFileParams);
                }

                if (formData && formData.data) {
                    this.filesList = formData.data;
                    this.filePage = {
                        currentPage: formData.currentPage,
                        pageSize: formData.pageSize,
                        totalPageNum: formData.totalPageNum
                    };
                    if (this.isHasAuth()) {
                        for (let i = 0; i < this.filesList.length; i++) {
                            let cur = this.filesList[i];
                            let index = cur.filePath.lastIndexOf('.');
                            let fileType = cur.filePath.substr(index);
                            if (fileType === '.pdf' || fileType === '.PDF') { // 是PDF判断当前人是否有权限
                                cur.showSignBtn = true;
                                let res = this.isShowSignBtnState(cur);
                                if (res == true) {
                                    cur.showDownSignBtn = true;
                                } else {
                                    cur.showDownSignBtn = false;
                                }
                            } else {
                                cur.showSignBtn = false;
                                cur.showDownSignBtn = false;
                            }
                        }
                    }
                }
                // console.log(formData);
            },
            async handleTaskFileSearch () {
                if (isEmpty(this.signBusiTaskInstanceId)) {
                    return;
                }
                this.searchTaskFileParams.processInstanceId = this.signBusiProcessInstanceId;
                this.searchTaskFileParams.taskId = this.signBusiTaskInstanceId;
                this.searchTaskFileParams.currentPage = this.taskFilePage.currentPage;
                this.searchTaskFileParams.pageSize = this.taskFilePage.pageSize;
                let formData = await getProcessTaskFiles(this.searchTaskFileParams);
                if (formData && formData.data) {
                    this.taskFilesList = formData.data;
                    this.taskFilePage = {
                        currentPage: formData.currentPage,
                        pageSize: formData.pageSize,
                        totalPageNum: formData.totalPageNum
                    };
                    if (this.isHasAuth()) {
                        for (let i = 0; i < this.taskFilesList.length; i++) {
                            let cur = this.taskFilesList[i];
                            let index = cur.filePath.lastIndexOf('.');
                            let fileType = cur.filePath.substr(index);
                            if (fileType === '.pdf' || fileType === '.PDF') { // 是PDF判断当前人是否有权限
                                cur.showSignBtn = true;
                                let res = this.isShowSignBtnState(cur);
                                if (res == true) {
                                    cur.showDownSignBtn = true;
                                } else {
                                    cur.showDownSignBtn = false;
                                }
                            } else {
                                cur.showSignBtn = false;
                                cur.showDownSignBtn = false;
                            }
                        }
                    }
                }
                // console.log(formData);
            },
            queryTaskFileListData (currentPage) {
                this.taskFilePage.currentPage = currentPage;
                this.handleTaskFileSearch();
            },
            handleDownload (fileobj) {
                this.downLoading = true;
                // this.fileDownloadUrl = `${API_FILE_DOWNLOAD}${fileobj.filePath}`;
                let url = `${API_FILE_DOWNLOAD}${fileobj.filePath}`;
                this.download(url);
                this.readFile(fileobj);
                setTimeout(() => {
                    this.downLoading = false;
                }, 2000);
            },
            async handleAddProcessFileShare (fileobj) {
                fileobj.processInstanceId = this.processInstanceId;// 文件目前在的流程实例ID，而不是文件上传时的流程实例ID，用于处理共享的文件
                await addProcessFileShare(fileobj);
                await this._initPage();
            },
            async handleDelProcessFileShare (fileobj) {
                this.$confirm(`您确定要取消文件[ ${fileobj.fileName} ]给所属主流程和任务可见吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await delProcessFileShare(fileobj.id, this.processInstanceId);
                    await this._initPage();
                }).catch(() => {});
            },
            handleFileDelete (fileobj) {
                // console.log('===========' + fileobj.showDeleteBtn);
                let param = {
                    processInstanceId: this.processInstanceId,
                    taskInstanceId: fileobj.taskId ? fileobj.taskId : null,
                    fileId: fileobj.id
                };
                this.$confirm(`您确定要删除文件[ ${fileobj.fileName} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    if (fileobj.taskId) {
                        await delTaskFile(param);
                    } else {
                        await delProcessFile(param);
                    }
                    this.readFile(fileobj);
                }).catch(() => {});
            },
            async queryUserList (userName) {
                this.loading = true;
                let userData = await getUserList({ name: userName });
                this.userList = userData.data;
                this.loading = false;
            },
            chooseUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            selectTrigger (selected) {
                this.searchFileParams.userId = selected.selectedUserIds;
                this.handleFileSearch();
            },
            async handleShowArchiveTree (row) {
                if (this.currentUser.userId !== row.createdBy) {
                    this.$message.warning('上传人才可以进行该操作');
                    return;
                }
                if (row.approvalStatus !== 1 && row.approvalStatus !== 2) { // 审核中和归档后的文件不可以再次修改目录
                    this.selectedRow = row;
                    this.loadTimer = new Date().getTime();
                    this.isShowArchiveTemplateTree = true;
                }
            },
            async chooseArchiveNodeConfirm () {
                this.isShowArchiveTemplateTree = false;
                let taskFile = {id: this.selectedRow.taskFileId};
                let idArr = [];
                if (this.targetDirectory.targetDirectoryId) {
                    idArr.push({tagId: this.targetDirectory.targetDirectoryId, label: this.targetDirectory.targetDirectoryName, tagFlg: 1});
                }
                taskFile.tags = idArr;
                await saveTags(taskFile);
                this.handleFileSearch();
            },
            handleTreeNode (data, node, tree) {
                this.targetDirectory.targetDirectoryId = data.id;
                this.targetDirectory.targetDirectoryName = data.label;
            },
            approvalFilesSelectChoose (selected) {
                if (selected && selected.length > 0 && selected[0] === undefined) {
                    return;
                }
                let ids = [];
                let names = [];
                selected.forEach(item => {
                    ids.push(item.id);
                    names.push(item.label);
                });
                this.approvalFilesDirId = ids.join(',');
                this.approvalFilesDirName = names.join(',');
            },
            filterTag (value, row) {
                return row.tag === value;
            },
            async previewFile (file) {
                // let operationType = '&operationType=2';
                let url = `${API_FILE_DOWNLOAD}${file.filePath}`;
                let index = url.lastIndexOf('.');
                let fileType = url.substr(index);
                if (fileType === '.png' || fileType === '.PNG' ||
                     fileType === '.pdf' || fileType === '.PDF' ||
                     fileType === '.JPG' || fileType === '.jpg' ||
                     fileType === '.JPEG' || fileType === '.jpeg' ||
                     fileType === '.BMP' || fileType === '.bmp' ||
                     fileType === '.GIF' || fileType === '.gif' ||
                    fileType === '.TXT' || fileType === '.txt') {
                    let tempwindow = window.open();
                    url = url + '&operationType=2';
                    tempwindow.location = url;
                } else if (fileType === '.doc' || fileType === '.docx' || fileType === '.xls' || fileType === '.xlsx' || fileType === '.ppt' || fileType === '.pptx') {
                    let previewUrl = await getPreviewFileUrl(file);
                    if (previewUrl) {
                        let tempwindow = window.open();
                        tempwindow.location = previewUrl;
                    }
                } else {
                    this.$message.error('此格式文件不支持预览');
                }
            },
            async handleBatchUpdProcessFilesStatus () {
                let params = {
                    processInstanceId: this.processInstanceId,
                    taskInstanceId: this.taskId
                };
                await batchUpdProcessFilesStatus(params);
                this.handleFileSearch();
            },
            async readFile (file) {
                await addProcessFileReadRecord(file);
                this.handleFileSearch();
            },
            handleFileDesc (file) {
                this.selectedFile = file;
                this.isShowFileDesc = true;
            },
            async updateFileDesc () {
                let isValid = false;
                this.$refs['selectFileForm'].validate((valid) => {
                    if (valid) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                });
                if (!isValid) {
                    return false;
                }
                await updateFileDesc(this.selectedFile);
                this.handleFileSearch();
                this.isShowFileDesc = false;
            },
            handleClose (done) {
                this.handleFileSearch();
                done();
            },
            async handleArchiveFileApply (row) { // 共享所属流程
                // console.log(row);
                this.$confirm(`您确定要将文件[ ${row.fileName} ]共享给所属流程吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let param = {
                        approvalInstanceId: this.processInstanceId,
                        fileIds: row.id
                    };
                    await addApprovalFileViewForProcessByIds(param);
                    this.handleFileSearch();
                }).catch(() => {});
            },
            async handleDelArchiveFileApply (row) { // 取消共享给所属流程
                // console.log(row);
                this.$confirm(`您确定要对文件[ ${row.fileName} ]取消共享给所属流程吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let param = {
                        approvalInstanceId: this.processInstanceId,
                        fileIds: row.id
                    };
                    await delApprovalFileViewForProcessByIds(param);
                    this.handleFileSearch();
                }).catch(() => {});
            },
            async handleBathApprovalFiles () {
                if (!isEmpty(this.selectedFiles.selectedFileIds)) {
                    this.approvalDialogTile = '批量归档审核';
                    this.isShowApprovalDialog = true;
                    this.startProcessloading = false;
                    this.approvalInfo.templateId = this.templateId;
                    this.approvalInfo.processInstanceId = this.processInstanceId;
                    this.approvalInfo.fileId = this.selectedFiles.selectedFileIds;
                } else {
                    this.$message.warning('请选择需要审核的文件');
                }
            },
            async handleFinalApproval () {
                let isValid = false;
                this.$refs['approvalInfoForm'].validate((valid) => {
                    if (valid) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                });
                if (!isValid) {
                    return false;
                }
                this.startProcessloading = true;
                await approvalArchiveFileByIds(this.approvalInfo);
                await this._initPage();
                this.startProcessloading = false;
                this.isShowApprovalDialog = false;
                // 审核结束
                this.selectedFiles = {
                    selectedFileIds: '', // 选中的文件ID
                    selectedFileNames: '' // 选中的文件名称
                };
            },
            handleGoArchiveNav () {
                this.navArchiveNav();
            },
            handleFullScreen () {
                this.$emit('handleFullScreen');
            },
            handleSelectionChange (rows) {
                this.selectedFiles.selectedFileIds = '';
                this.selectedFiles.selectedFileNames = '';
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (isEmpty(this.selectedFiles.selectedFileIds)) {
                                    this.selectedFiles.selectedFileIds = row.id;
                                    this.selectedFiles.selectedFileNames = row.fileName;
                                } else {
                                    this.selectedFiles.selectedFileIds = this.selectedFiles.selectedFileIds + ',' + row.id;
                                    this.selectedFiles.selectedFileNames = this.selectedFiles.selectedFileNames + ',' + row.fileName;
                                }
                            }
                        });
                    } else {
                        this.selectedFiles.selectedFileIds = rows.id;
                        this.selectedFiles.selectedFileNames = rows.fileName;
                    }
                }
                // console.log(this.selectedFiles);
            },
            handleSingleApprovalFileById (row) {
                this.loadTimer = new Date().getTime();
                this.selectedFiles.selectedFileIds = row.id;
                this.selectedFiles.selectedFileNames = row.fileName;
                this.approvalDialogTile = '文件归档审核';
                this.isShowApprovalDialog = true;
                this.startProcessloading = false;
                this.approvalInfo.templateId = this.templateId;
                this.approvalInfo.fileId = this.selectedFiles.selectedFileIds;
            },
            async handleCanViewTaskConfig (row) {
                this.loadTimer = new Date().getTime();
                this.isShowFileCanViewPop = true;
                this.currentFileId = row.id;
            },
            taskSelectConfirmClick (param) {
                this.isShowFileCanViewPop = false;
            },
            taskSelectCancelClick () {
                this.isShowFileCanViewPop = false;
            },
            handlePictureCardPreview (file) {
                this.dialogImageUrl = `${API_IMG_DOWNLOAD}${file.filePath}`;
                this.dialogVisible = true;
            }
        }
    };
</script>


<style lang="less">
    .approval-files{
       height: 100%;
       .approval-files-list{

       }
       .task-files-list{

       }
    }
    .process-files {
        margin-bottom: 20px;
    }
    .el-upload-dragger{
        width: 245px;
        margin-left:-15px;
        background-color: #fff;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        box-sizing: border-box;
        // width: 300px;
        height: 140px;
        text-align: center;
        position: relative;
        overflow: hidden;
    }
    .img-progress{
      text-align:center;
      padding-top:50px;
    }

</style>



// WEBPACK FOOTER //
// src/components/ApprovalFiles/ApprovalFiles.vue